<template>
  <div>
    <div class="operator-card">

      <div class="operator-card_header">
        <span class="operator-card_header_name">{{operator.module_name}} / {{operator.op_name}}</span>
      </div>

      <div class="operator-card_content">
        <div v-for="(param,key) in params" :key="key" class="operator-card_content_channels content-item" >
          <div class="left">
            <span class="title">{{key}}:</span>
          </div>
          <div class="right">
            <span class="title">{{param}}</span>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>

export default {
  name: "OperatorsAPIItem",
  props: ['operator'],
  data () {
    return {
      params: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init(){
      this.params = JSON.parse(this.operator.params)
    },
    edit(operator){
      this.$emit('edit', operator)
    }
  }
}
</script>

<style lang="scss" scoped>

  .operator-card {
    border-radius: 10px;
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    padding-bottom: 10px;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    overflow: hidden;
    &_header {
      font: 300 1.41rem/1.95rem "Roboto", Arial, sans-serif;
      text-transform: uppercase;
      color: #000;
      background: #f4f3ef;
      padding: 1rem 2rem;
      border-radius: 0.85rem 0.85rem 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &_content {
      font: 300 1.15rem/1.5rem "Roboto", Arial, sans-serif;
      text-align: center;
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          height: 100%;
        }
        .left{
          width: 30%;
        }
        .right{
          width: 70%;
        }
      }
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }


</style>
